export default {
    "name": "End of the Skyline",
    "short_name": "Skyline Tactics",
    "scope": "./",
    "start_url": "index.html",
    "display": "fullscreen",
    "background_color": "#222",
    "theme_color": "#222"
}
